








































































import { Vue, Component, PropSync, Ref, Prop, Watch } from 'vue-property-decorator'
import { FormSerieFiscal } from '@/models/SerieFiscal'
import { obrigatorio, maxDigit } from '@/shareds/regras-de-form'

@Component
export default class DialogoFormSerieFiscal extends Vue {
	@Ref() form!: HTMLFormElement
	@PropSync('value') mostra!: boolean
	@Ref() campoDeAmbiente!: HTMLInputElement
	@Prop({ type: Function, default: criarSerieFiscal }) initialValue!: () => FormSerieFiscal
	@Prop({ type: Boolean, default: false }) disabled!: boolean
	@Prop({ type: Boolean, default: false }) readonly!: boolean
	@Prop({
		type: Object,
		default: () => ({
			series: [],
		}),
	}) rules!: {
		[key in keyof FormSerieFiscal]?: ((serieFiscal: FormSerieFiscal) => true | string)[]
	}
	serieFiscal: FormSerieFiscal = criarSerieFiscal()
	obrigatorio = obrigatorio
	maxDigit = maxDigit
	isEdicao = false

	get rulesComputadas(): { [key in keyof FormSerieFiscal]?: ((value: any) => true | string)[] } {
		return this.rules
			? Object
				.entries(this.rules)
				.reduce((rulesPorKey,  [key, rules]) =>  ({
					...rulesPorKey,
					[key]: rules?.map(rule => () => rule(this.serieFiscal)) || [],
				}), {})
			: {}
	}

	@Watch('mostra')
	onChangeMostra(mostra: boolean) {
		if (!mostra) return
		this.serieFiscal = JSON.parse(JSON.stringify(this.initialValue()))
		this.serieFiscal.id ? this.isEdicao = true : this.isEdicao = false

		setTimeout(() => {
			this.form.resetValidation()
			setTimeout(() => {
				this.campoDeAmbiente.focus()
			})
		})
	}

	confirmar() {
		if (!this.form.validate()) return
		this.$emit('confirma', this.serieFiscal)
		this.$emit('input', false)
	}
}

function criarSerieFiscal(): FormSerieFiscal {
	return {
		id: '',
		serie: null,
		numeroNota: 1,
		tipo: 'Venda',
		ambiente: 'Homologação',
	}
}

